import React, { Component } from 'react';
import {api} from "../rest";
import swal from "sweetalert2";
import Loading from "./loading";

export default class FormEditBus extends Component {
	constructor() {
		super();
		this.state = {
			camion: "",
			modelo: "",
			fetching: "",
			editable: false
		}
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.handleModelChange = this.handleModelChange.bind(this);
		this.handleBusChange = this.handleBusChange.bind(this);
		this.handleBusDelete = this.handleBusDelete.bind(this);
	}
	componentWillMount () {
		this.setState({fetching: true});
		api.get(`buses/${this.props.busId}`)
		.then(({data})=>{
			this.setState({
				camion: data.name,
				modelo: this.props.modelId
			});
		})
		.catch((error)=>{
			if (error.response) {
				swal("Error", `Status: ${error.response.status}`,"error");
			}
		})
		.then(()=>{
			this.setState({fetching: false});
		})
	}
	handleFormSubmit (e) {
		e.preventDefault();
		this.setState({fetching: true});
		api.patch(`buses/${this.props.busId}`,{name: this.state.camion,bus_model_id: this.state.modelo})
		.then(()=>{
			swal("Autobus actualizado",this.state.camion,"success");
			this.props.update();
			this.setState({camion: "",modelo: ""});
		})
		.catch((error)=>{
			if(error.response) {
				if (error.response,status === 406) {
					swal("Error", `Ya existe un autobus con ese nombre`,"info");
				} else {
					swal("Error", `Status: ${error.response.status}`,"error");
				}
			} else {
				swal("Error",error.message,"error");
				console.error(error);
			}
		})
		.then(()=>{
			this.setState({fetching: false});
		})
	}
	handleBusDelete () {
		swal({
			title: "Desea eliminar este autobus?",
			confirmButtonText: "Si",
			confirmButtonClass: "alert",
			showCancelButton: true,
			cancelButtonText: 'No',
			type: "info"
		}).then(()=>{
			api.delete(`buses/${this.props.busId}`)
			.then(()=>{
				swal({
					title: "Autobus eliminado",
					type: "success"
				});
				this.props.update();
				this.props.closeModal();
			})
			.catch(({response: {status}})=>{
				swal({
					title: "Ha ocurrido un error",
					text: `Status: ${status}`,
					type: "error"
				});
			});
		},(dismiss)=>{
			if (dismiss === 'cancel') {

			}
		})
	}
	handleModelChange({target: {value}}) {
		this.setState({modelo: value});
	}
	handleBusChange({target: {value}}) {
		this.setState({camion: value});
	}
	render() {
		const models = this.props.data.map(({name,id},i)=><option key={i} value={id}>{name}</option>)
		return (
			<form className="group columns small-12" onSubmit={this.handleFormSubmit}>
				<Loading loading={this.state.fetching}/>
				<div className="group-title">Editar autobus</div>
				<div className="row">
					<label className="columns small-6">
						<em>Modelo</em>
						<select value={this.state.modelo} onChange={this.handleModelChange} required disabled={this.context.getLp() < 2 || !this.state.editable}>
							<option disabled value=""> --- Selectiona --- </option>
							{models}
						</select>
					</label>
					<label className="columns small-6">
						<em>Autobus</em>
						<input type="text" value={this.state.camion} onChange={this.handleBusChange} required disabled={this.context.getLp() < 2 || !this.state.editable}/>
					</label>
					<label className="columns small-4">
						<em></em>
						<button type="button"
						        className="button warning expanded"
								disabled={this.state.fetching || this.context.getLp() < 2}
								onClick={()=>this.setState({editable: !this.state.editable})}
						>
							Editar
						</button>
					</label>
					<label className="columns small-4">
						<em></em>
						<button type="submit" className="button success expanded"
								disabled={this.state.fetching || this.context.getLp() < 2 || !this.state.editable}
						>
							Guardar
						</button>
					</label>
					<label className="columns small-4">
						<em></em>
						<button type="button" className="button alert expanded" onClick={this.handleBusDelete} disabled={this.state.fetching || this.context.getLp() < 3}>Eliminar</button>
					</label>
				</div>
			</form>
		);
	}
}

FormEditBus.contextTypes = {
	getLp: React.PropTypes.func
};


/** WEBPACK FOOTER **
 ** ./src/components/form-edit-bus.js
 **/